import { render, staticRenderFns } from "./bkmvPopUpProductPrompt.vue?vue&type=template&id=3f331efa&scoped=true"
import script from "./bkmvPopUpProductPrompt.vue?vue&type=script&lang=js"
export * from "./bkmvPopUpProductPrompt.vue?vue&type=script&lang=js"
import style0 from "./bkmvPopUpProductPrompt.vue?vue&type=style&index=0&id=3f331efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f331efa",
  null
  
)

export default component.exports